<template>
    <component :is="tagName" :class="classes">
        {{ label }}
    </component>
</template>

<script src="./kl-ol-map-info-item.ts"></script>
